export const commonEndpoint = "v1/admin";
export const commonEndpointV2 = "v2/admin";
export const commonEndpointV3 = "v1/admin/master";

export const adminBaseUrl = "v1/admin/users";
export const adminList = `${adminBaseUrl}/`;
export const getAdminPermissions = `${adminBaseUrl}/permissions}`;
export const adminRoles = `${adminBaseUrl}/roles/`;
export const userPermissions = `${adminBaseUrl}/permissions/`;
export const featuresAndPermissions = `${adminBaseUrl}/features-and-permissions/`;

export const needsBaseURL = `v1/admin/needs`;
export const needsList = `${needsBaseURL}/needs-list/`;
export const needDetails = `${needsBaseURL}/need-details/`;
export const needsDownload = `${needsBaseURL}/needs-excel-pdf-convert/`;
export const needStatus = `${needsBaseURL}/needs-status/`;
export const needsFilters = `${needsBaseURL}/needs-filter/`;
export const needsArea = `${needsBaseURL}/areas`;
export const needsBrand = `${needsBaseURL}/brand`;

export const schemesBaseURL = "v1/admin/schemes";
export const schemesMasters = `${schemesBaseURL}/master/`;
export const enquirySchemeList = `${commonEndpoint}/schemes/enquired-schemes-list/`;
export const enquirySchemeListById = `${commonEndpoint}/schemes/enquired/`;
export const enquirySchemeNotification = `${commonEndpoint}/schemes/enquired/notification`;
export const schemesList = `${commonEndpoint}/schemes/list`;
export const addSchemeAPI = `${schemesBaseURL}/`;
export const schemeDetails = `${schemesBaseURL}/`;
export const schemeEligibility = `${schemesBaseURL}/eligibility/`;
export const schemeApprove = `${schemesBaseURL}/approve/`;
export const schemes = `${commonEndpoint}/schemes/`;

export const masterSchemes = `${commonEndpoint}/schemes/master/`;
export const stateMaster = `${commonEndpoint}/master/state`;
export const districtMaster = `${commonEndpoint}/master/district/`;
export const cityMaster = `${commonEndpoint}/master/city/`;

// Served by the dedicated admin-hospital-service (basePath v1/admin/hospitals),
// not admin-master-service.
export const hospitalsBaseURL = `${commonEndpoint}/hospitals`;
export const hospitalSchemesBaseURL = `${hospitalsBaseURL}/hospital-schemes`;
export const hospitalFacilitiesBaseURL = `${hospitalsBaseURL}/hospital-facilities`;
export const hospitalSpecialitiesBaseURL = `${hospitalsBaseURL}/hospital-specialities`;

export const choicesList = `${commonEndpointV2}/choices/`;
export const choicesListv2 = `${commonEndpointV2}/choices/`;
export const choicesListV3 = `${commonEndpoint}/surveyors/choice-list/`;
export const choicesResponseList = `${commonEndpoint}/choices/choices/`;
export const choicesViewResponse = `${commonEndpoint}/choices/choice-basic/`;
export const choicesMaster = `${commonEndpointV2}/choices/masters`;
export const submitted_choices_list = `${commonEndpointV2}/choices/submitted-choices-list`;
export const choice_user_details = `${commonEndpointV2}/choices/users-choice-details`;
export const choice_family_details = `${commonEndpointV2}/choices/family-choice-details`;
export const choice_filter = `${commonEndpointV2}/choices/filter`;
export const choice_family_filter = `${commonEndpointV2}/choices/family-filter`;

export const services = `${commonEndpoint}/services/`;
export const services_details = `${commonEndpoint}/services/service-details/`;
export const status_list = `${commonEndpoint}/services/status-list/`;
export const filter_list_filter = `${commonEndpoint}/services/filters`;
export const service_category_list=`${commonEndpoint}/services/categories`

export const jobs = `${commonEndpoint}/jobs/jobs-list`;
export const job_application = `${commonEndpoint}/jobs/job-applications-list`;
export const jobs_application_status = `${commonEndpoint}/jobs/application-status/`;
export const jobs_status = `${commonEndpoint}/jobs/job-status/`;
export const job_filter = `${commonEndpoint}/jobs/filters/`;
export const jobs_application_filter = `${commonEndpoint}/jobs/application/filters`;
export const job = `${commonEndpoint}/jobs/`;
export const job_application_details = `${commonEndpoint}/jobs/application/`;

export const surveyor_list = `${commonEndpoint}/surveyors/list`;
export const surveyors = `${commonEndpoint}/surveyors/`;
export const surveyor_submitted_choice = `${commonEndpoint}/surveyors/submitted-choice-list`;
export const surveyor_download_List = `${commonEndpoint}/surveyors/submitted-choice-list/survey-report-tasks`;
export const surveyor_download=`${commonEndpoint}/surveyors/submitted-choice-list/download-survey-report`
export const surveyor_submitted_choice_details = `${commonEndpoint}/surveyors/submitted-choice-details`;
export const surveyor_submitted_recording = `${commonEndpoint}/surveyors/submitted`;
export const surveyors_filter = `${commonEndpoint}/surveyors/filters`;

export const app_users_list = `${commonEndpoint}/users/app-users/list`;
export const app_users_download_list = `${commonEndpoint}/users/app-users/user-download-tasks-list`;
export const download_users_data = `${commonEndpoint}/users/app-users/download-user-report`;
export const app_users = `${commonEndpoint}/users/app-users/`;

// admin-rewards-service moved every route under /merchant-reward or
// /user-reward (commit "merchant reward bug", 2a48270) - these reflect the
// confirmed current paths, not the module names (the list/redeem endpoints
// for this "user rewards" screen happen to live under /merchant-reward).
export const rewards_listing = `${commonEndpoint}/rewards/merchant-reward/rewards-list`;
export const rewards_user = `${commonEndpoint}/rewards/user-reward/user`;
export const rewards_redemption_history = `${commonEndpoint}/rewards/user-reward/redemption-history`;
export const rewards_redemption = `${commonEndpoint}/rewards/user-reward/redemption`;
export const rewards_redeem = `${commonEndpoint}/rewards/merchant-reward`;
// User-raised redemption requests (rewards.redemption_requests), reviewed and
// paid out by admin - distinct from the direct-redeem flow above.
export const rewards_redemption_requests = `${commonEndpoint}/rewards/user-app/redemption-requests`;

// Merchant and Voucher API endpoints - same /merchant-reward restructure
// noted above also moved these (commit "merchant reward bug", 2a48270).
export const merchantBaseUrl = `${commonEndpoint}/rewards/merchant-reward`;
export const createMerchant = `${merchantBaseUrl}/merchant`;
export const getMerchants = `${merchantBaseUrl}/merchant`;
export const createVouchers = `${merchantBaseUrl}/vouchers`;
export const getVouchers = `${merchantBaseUrl}/vouchers`;
export const assignVouchersToMerchant = `${merchantBaseUrl}/assign-to-merchant`;
export const assignVouchersToUser = `${merchantBaseUrl}/assign-to-user`;
export const redeemVoucher = `${merchantBaseUrl}/voucher-redemption`;
export const verifyVoucherCode = `${merchantBaseUrl}/verifyOtp`;
export const verifyOtp = `${merchantBaseUrl}/verifyOtp`;
export const userForMerchantList = `${merchantBaseUrl}/vouchers/app-users/list`;

export const getExcelUploadedList = `${adminBaseUrl}/app-users/excel-upload-list`;
export const uploadexcelFileEndPoint= `${adminBaseUrl}/app-users/add-edit-user/upload`;
export const downloadExcel = `${adminBaseUrl}/app-users/download-excel-file/download`;
export const downloadExcelForSmsWhstapp = `${adminBaseUrl}/notification-users/download-sms-whatsapp-excel-file/download`;
export const create_user = `${adminBaseUrl}/app-users/add-new-user`;
export const modify_user = `${adminBaseUrl}/app-users/edit-user`;


//client mapping

export const create_roles=`${adminBaseUrl}/v2/roles`;
export const get_roles=`${adminBaseUrl}/v2/roles`;
export const get_roles_details=`${adminBaseUrl}/v2/roles/details`;
export const add_admin=`${adminBaseUrl}/v2/users`;
export const list_clients=`${adminBaseUrl}/v2/users`;
export const get_individual_client_details=`${adminBaseUrl}/v2/users/details`

//organizations (multi-tenancy)
export const organizationsBaseURL=`${adminBaseUrl}/organizations`;
export const organizationDetails=`${organizationsBaseURL}/details`;
export const organizationModulesCatalog=`${organizationsBaseURL}/modules`;

export const uploadexcelFileNotificationEndPoint= `${adminBaseUrl}/notification-users/upload`;
export const whatsappSmsnotificationList=`${adminBaseUrl}/notification-users/sms-whatsapp-notifications`


//bucketing of needs
export const getNeedLabels=`${commonEndpoint}/needs/labels`
export const getSuggestedLabel=`${commonEndpoint}/needs/labels/suggestions`
export const updateNeeds=`${commonEndpoint}/needs/needs-status/bulk`

//notifications urls
export const notification_endpoint=`${commonEndpoint}/qsubscribers/publish-notification`

//landing pages urls
export const landing_page_endpoint=`${commonEndpointV3}/landing-page/contents`
export const landing_page_rules_endpoint=`${commonEndpointV3}/landing-page/rules`
export const landing_page_rules_check_overlap_endpoint=`${commonEndpointV3}/landing-page/rules/detect-overlap`
export const landing_page_rules_user_count_endpoint=`${commonEndpointV3}/landing-page/rules/user-count`

//voice transcription
export const voiceTranscription = `${commonEndpoint}/voice/transcribe`;

//global master data
export const globalMasterUrl=   `${commonEndpoint}/master/profile`

//fm portal
export const fm_portal_url=`${commonEndpoint}/workflows/fmportal/`

//cms urls
export const cmsBaseURL = "v1/admin/cms";
export const cms_news_endpoint = `${cmsBaseURL}/news`;
export const cms_news_source_endpoint = `${cmsBaseURL}/news-source`;
export const cms_banner_endpoint = `${cmsBaseURL}/banner`;
export const cms_media_endpoint = `${cmsBaseURL}/media`;
export const cms_amiforyou_endpoint = `${cmsBaseURL}/amiforyou`;
export const cms_app_polling_endpoint = `${cmsBaseURL}/app-polling`;